"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHeading = exports.StyledCaret = exports.StyledCardHeader = exports.StyledCardContent = exports.StyledCard = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../../shared");

var _utils = require("../../../shared/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledCardBorderColor = (0, _utils.hexToRgba)(_shared.theme.palette.brand.primary.gray, 0.2);
const StyledCardDisabledBorderColor = (0, _utils.hexToRgba)(_shared.theme.palette.ui.neutral.grey7, 0.2);

const StyledCard = _styledComponents.default.div.withConfig({
  displayName: "style__StyledCard",
  componentId: "sc-1y1kc6l-0"
})(["", ";width:", ";padding:16px 27px 0px 32px;display:flex;flex-direction:column;border:", ";border-radius:4px;background:", ";box-sizing:border-box;color:", ";", ";:hover{background:", ";}:focus{outline:none;background:", ";border:2px solid ", ";}:active{background:", ";border:2px solid ", ";outline:none;}"], _shared.theme.typography.body.css, ({
  width
}) => width && width, ({
  disabled
}) => disabled ? `1px solid rgba(
      	${StyledCardBorderColor.red},
      	${StyledCardBorderColor.green},
      	${StyledCardBorderColor.blue},
      	${StyledCardBorderColor.opacity}
			);` : `2px solid rgba(
      	${StyledCardDisabledBorderColor.red},
      	${StyledCardDisabledBorderColor.green},
      	${StyledCardDisabledBorderColor.blue},
      	${StyledCardDisabledBorderColor.opacity});`, _shared.theme.palette.brand.primary.white, ({
  disabled
}) => disabled ? `${_shared.theme.palette.ui.neutral.grey7}` : `${_shared.theme.palette.brand.primary.charcoal}`, ({
  disabled
}) => disabled && `
		pointer-events: none;

	`, `rgba(
      	${StyledCardBorderColor.red},
      	${StyledCardBorderColor.green},
      	${StyledCardBorderColor.blue},
      	${StyledCardBorderColor.opacity})`, _shared.theme.palette.brand.primary.white, _shared.theme.palette.ui.cta.yellow, _shared.theme.palette.brand.primary.white, `rgba(
      	${StyledCardBorderColor.red},
      	${StyledCardBorderColor.green},
      	${StyledCardBorderColor.blue},
      	${StyledCardBorderColor.opacity})`);

exports.StyledCard = StyledCard;

const StyledCaret = _styledComponents.default.div.withConfig({
  displayName: "style__StyledCaret",
  componentId: "sc-1y1kc6l-1"
})(["display:flex;transition:all 0.3s ease-in-out;transform-origin:center center;", ";svg{", ";}"], ({
  collapse
}) => collapse && `
    transform:rotateZ(180deg);
  `, ({
  disabled
}) => disabled && `fill: ${_shared.theme.palette.ui.neutral.grey7}`);

exports.StyledCaret = StyledCaret;

const StyledCardHeader = _styledComponents.default.div.withConfig({
  displayName: "style__StyledCardHeader",
  componentId: "sc-1y1kc6l-2"
})(["display:flex;justify-content:space-between;align-items:center;font-size:", ";line-height:", ";padding-bottom:14px;"], _shared.theme.typography.body.fontSize, _shared.theme.typography.body.lineHeight);

exports.StyledCardHeader = StyledCardHeader;

const StyledHeading = _styledComponents.default.div.withConfig({
  displayName: "style__StyledHeading",
  componentId: "sc-1y1kc6l-3"
})(["word-break:break-all;"]);

exports.StyledHeading = StyledHeading;

const StyledCardContent = _styledComponents.default.div.withConfig({
  displayName: "style__StyledCardContent",
  componentId: "sc-1y1kc6l-4"
})(["box-sizing:border-box;padding-bottom:16px;height:", ";display:", ";"], ({
  height
}) => height ? height : 'auto', ({
  collapse
}) => collapse ? 'block' : 'none');

exports.StyledCardContent = StyledCardContent;